var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"id":_vm.id,"data":_vm.dataValue,"resize":"true","xkey":"label","ykeys":['value'],"grid":"true","grid-text-weight":"bold","bar-color":['#FF6384']}})}
var staticRenderFns = []

export { render, staticRenderFns }